import Vue from 'vue'
import 'vxe-table-quantdata/lib/style.css'
import {reportYear} from '../../util/util'
import XEUtils from "xe-utils";  
import httpManager from "../../util/common";
import {entityOaid} from "../../util/util";
import { fn } from 'jquery';
import BScroll from 'better-scroll'

Vue.use('vxe-utils');
Vue.use('vxe-table');

let vm = {
    props:['input_is_show','tableColumn','is_ranking',"size","select_is_show"],
    data:()=>{
        return {  
            scroll:null,
            oaid:null,
            ticker:null,
            start_date:null,
            hot_word:null,
            gics_option:null,
            gics_options: null,
            gics:null,
            institution_option:null,
            institution:null,
            institution_list_all:null,
            subject_words:null,
            loading:false,
            sort_column:null,
            sort_order:null,
            data:[],
            hints:[],
            showHintsBox:false,
            closeClick: false,
            hot_word_flag:false,
            page:{
                size: "mini",
                total: 0, 
                currentPage: 1,
                pageSize: 10,
                align: 'center',
                pageSizes: [10, 20, 50, 100, 200, 500],
                layouts: ['PrevPage', 'Number','NextPage'],
                perfect: true,
                pagerCount: 3
            }
        }
    },
    methods:{
        // 排序按钮事件
        sortChangeEvent({ column, property, order }){
            this.sort_column=property
            this.sort_order=order
            this.page.currentPage=1
            if(!this.sort_order){
                this.sort_column=null
            }
            this.getReportData()
        },
         // gics搜索
        gicsFilter(inputValue, path) {
            return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
        },

        //机构搜素
        institutionFilter(inputValue, path){
            return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
        },
        // 获取oaid
        async getOaid(){
            let self=this
            let id=this.$route.params.oaid
            if(escape(id).indexOf("%u")<0){
                this.oaid=this.$route.params.oaid
            }else{
                await entityOaid.oaid(id).then(result => {
                    self.oaid =result
                  })
            }
        },

        // 获取gics行业
        getGicsIndustries(){
            let self = this
            let lang = this.$i18n.locale
            reportYear.gics("gics_tree_" + lang).then(result => {
              self.gics_options = result
            })
        },

         // 事件关联所处行业选项框
        gicsOnChange(value, selectedOptions) {
            this.gics = value[value.length-1]
        },
        institutionsOnChange(value, selectedOptions){
            this.institution=value[value.length-1]
        },

        // 获取证券机构
        getInstitutions(){
            let self=this
            httpManager("stock_report_institutions",null,null,null,null)
            .then(response=>{
                self.institution_list_all=response.data.data
                for(let item of self.institution_list_all){
                    item.label=item.institution
                    item.value=item.institution
                }
            })
            .catch((error)=>{
                console.log('error');
            })
        },  

        // 页面变化
        pageChange({ currentPage, pageSize }) {
            this.page.currentPage = currentPage
            this.page.pageSize = pageSize
            this.getReportData()
        },

        // 根据行业对应的编号找到对应的名字
        getGicsName(gics){
            let gics_industry = JSON.parse(window.sessionStorage.getItem('gics_tree_zh'))
            for(let item of gics_industry){
                if(gics==item['value']){
                    return item['label']
                }
                if(item.children){
                    for(let sub_item of item.children){
                        if(gics==sub_item['value']){
                            return sub_item['label']
                        }
                    }
                }
            }
        },
        //时间戳转换成标准时间
        timestampToTime(timestamp) {
            var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = date.getDate() <10 ? '0'+date.getDate():date.getDate()
            return Y+M+D;
        },

        // 获取前七天的日期
        getPreDate(){
            let cur_date=new Date().getTime()
            let pre_Date=cur_date-7*24*3600*1000
            this.start_date=this.timestampToTime(pre_Date)
        },

        // -----获取表格数据-----
        getReportData(){
            let self=this
            self.loading=true
            let params = new Map()
            params.set("pagenum", self.page.currentPage)
            params.set("pagesize", self.page.pageSize)
            if(self.gics){
                params.set('gics',self.gics)
            }
            if(self.institution){
                params.set('institution',self.institution)
            }
            if(self.subject_words){
                self.subject_words=self.subject_words.trim()
                params.set('subject',self.subject_words)
            }
            if(self.ticker){
                self.ticker=self.ticker.toUpperCase().trim()
                params.set('ticker',self.ticker)
            }
            if(self.is_ranking){
                params.set('start_date',self.start_date)
            }
            if(!self.select_is_show){
                params.set('oaid',self.oaid)
            }
            if(self.sort_column){
                params.set('sort_column',self.sort_column)
            }
            if(self.sort_order){
                params.set('sort_order',self.sort_order)
            }
            httpManager("stock_report_subject",params,null,null,null)
            .then(response=>{
                self.data=response.data.data
                if(!Array.isArray(self.data)){
                    self.data=[]
                }
                for(let item of self.data){
                    item.gics_name=self.getGicsName(item.gics)
                    item.researcher_name=item.researcher.join(' , ')
                    item.subject_words_list=[]
                    item.subject_headings.map((i)=>item.subject_words_list.push(i[0]))
                    item.subject_words=item.subject_words_list.join(' , ')
                }
                let page = response.data.page
                self.page.total = page.total
                self.loading=false
            })
            .catch((error)=>{
                self.loading = false
                console.log('error');
            })
        },

        // 筛选
        filter_report_data(){
            this.gics_flag=true
            this.institution_flag=true
            this.page.currentPage=1
            this.getReportData()
        },

        // 清除筛选
        clear_filter(){
            this.subject_words=null
            this.ticker=null
            this.gics_option=""
            this.institution_option=""
            this.gics=null
            this.institution=null
            this.page.currentPage=1
            this.getReportData()
        },

        // 将选中内容填入搜索框
        fillInput(index){
            this.showHintsBox=false
            this.closeClick=true
            if(this.hints&&this.hints[index]){
                let value=this.hints[index]
                this.hints=[]
                this.subject_words=value
            }
        },

        //搜索框失去焦点不展示hint-box
        closeHintsBox(){
            setTimeout(()=>{
                this.showHintsBox=false;
            },200)
        },

        // 获取联系词列表
        getHints(){
            if(this.subject_words){
                let self=this
                let params=new Map()
                params.set('subject',self.subject_words)
                httpManager("stock_report_subject_heading",params,null,null,null)
                .then(response=>{
                    let data=response.data.data
                    self.hints=[]
                    data.map((item)=>{
                        self.hints.push(item.subject_heading)
                        self.showHintsBox = true
                    })
                })
                .catch((error)=>{
                    console.log('error');
                })
            }
        },

        // 防抖
        throttle(){
            let timer=null
            let self=this
            return function(){
                if(timer) return
                timer=setTimeout(()=>{
                    self.getHints()
                    timer=null
                },500)
            }
        }
    },
    async mounted(){
        document.onclick=(e)=>{
            if(e.target.id!=="search_input" && e.target.id!=="scroll_bar_item"){
                this.closeHintsBox()
            }
        }
        if(!this.is_ranking){
            this.sort_column='publish_date'
            this.sort_order='desc'
        }
        this.hot_word=this.$route.query.hot_word
        if(this.hot_word){
            this.hot_word_flag=true
        }
        this.subject_words=this.hot_word
        await this.getOaid()
        this.getPreDate()
        this.getInstitutions()  
        this.getGicsIndustries()
        this.getReportData()
    },
    watch:{
        subject_words(){
            if(!this.hot_word_flag){
                if(!this.closeClick){
                    if(this.subject_words===''){
                        this.closeHintsBox()
                        return
                    }else{
                        this.throttle()()
                    }
                }else{
                    this.closeClick=false
                }
            }
            this.hot_word_flag=false
        }
    },
    updated() {
        // 监听主题词搜索的滚动条事件
        if(this.showHintsBox){
           /*获取滚动条*/
        let scrollBar = document.querySelector("#scroll_bar");
        /*获取滚动条小条*/
        let scrollBarItem = document.querySelector("#scroll_bar_item");
        /*获取滚动条小条可移动最大距离*/
        let barScrollHeight = scrollBar.offsetHeight - scrollBarItem.offsetHeight;
        /*获取内容盒子*/
        let scrollCon = document.querySelector("#scroll_con");
        /*获取展示盒子*/
        let scrollWarper = document.querySelector("#scroll_warper");
        /*获取内容盒子可移动最大距离*/
        let ConScrollHeight = scrollCon.scrollHeight - scrollWarper.getBoundingClientRect().height;
        //创建实例
        let scroll = BScroll(this.$refs.scrollWarper, {
          scrollY: true,//Y轴滚动
          bounce: false,//触顶底回弹
          mouseWheel: true,//开启鼠标滚动，可设为{}并配置
          probeType: 3,//监听滚动
          useTransition:false,
          momentum:true,
        });
  
        //鼠标滚动进度条滚动
        function onScroll(pos) {
          //获取内容盒子滚动距离
          let top = Math.abs(pos.y);
          /*计算比例  已滚动距离 / 最大滚动距离     */
          let scale = top / ConScrollHeight;
          /*设置小条的位置       比例 * 小条最大滚动距离    */
          scrollBarItem.style.top = scale * barScrollHeight + 'px';
        }
        // 监听当前实例上的钩子函数。如：scroll、scrollEnd 等。
        scroll.on('scroll', onScroll);
        //滚动条点击移动
        scrollBarItem.onmousedown = function (ev) {
          let e = ev || event;
          if (e.preventDefault) {
            e.preventDefault();
          } else {
            window.event.returnValue = false;
          }
          let bct = e.clientY - scrollBarItem.offsetTop;
          document.onmousemove = function (e) {
            let ev = e || event;
            let top = ev.clientY - bct;
            top = top <= 0 ? 0 : top;
            top = top >= barScrollHeight ? barScrollHeight : top;
            let scale = -(top / barScrollHeight);
            scrollBarItem.style.top = top + 'px';
            /*设置内容盒子滚动距离*/
            /*scrollTo(x, y, time, easing, extraTransform)*/
            scroll.scrollTo(0, scale * ConScrollHeight);
          };
          document.onmouseup = function () {
             document.onmousemove = null;
          };
        };
      }
    },
}

Vue.component("report-table", vm)
export default vm


// WEBPACK FOOTER //
// ./src/research_report/js/report_table.js